"use client";

import type React from "react";

import { useMemo } from "react";
import Logo from "assets/img/logo.png";
import { HiX } from "react-icons/hi";
import { SidebarSection } from "./components/sidebarSection";
import {
  MdHome,
  MdPerson,
  MdArticle,
  MdSupervisorAccount,
} from "react-icons/md";

import routes from "routes";

interface Route {
  path: string;
  show?: boolean;
  admin?: boolean;
  icon: React.ReactNode;
  name: string;
}

interface Section {
  title: string;
  icon: React.ReactNode;
  routes: Route[];
}

const groupRoutes = (routes: Route[]): Section[] => {
  const sections: Section[] = [
    {
      title: "Principal",
      icon: <MdHome className="h-4 w-4" />,
      routes: routes.filter(
        (route) => route.path === "default"
      ),
    },
    {
      title: "Clients",
      icon: <MdPerson className="h-4 w-4" />,
      routes: routes.filter(
        (route) => (route.path === "client" || route.path === "family") && route.show
      ),
    },
    {
      title: "Catalogue",
      icon: <MdArticle className="h-4 w-4" />,
      routes: routes.filter(
        (route) => route.path === "article" && route.show
      ),
    },
    {
      title: "Commercial",
      icon: <MdArticle className="h-4 w-4" />,
      routes: routes.filter(
        (route) =>
          (route.path === "devis" ||
            route.path === "commande" ||
            route.path === "bon-commande") &&
          route.show
      ),
    },
    {
      title: "Facturation",
      icon: <MdArticle className="h-4 w-4" />,
      routes: routes.filter(
        (route) =>
          (route.path === "invoice" || route.path === "cerfa") &&
          route.show
      ),
    },
    {
      title: "Administration",
      icon: <MdSupervisorAccount className="h-4 w-4" />,
      routes: routes.filter(
        (route) =>
          (route.path === "staff" || route.path === "subscriptions") &&
          route.show &&
          route.admin
      ),
    },
  ];

  return sections.filter((s) => s.routes.length > 0);
};

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;
  const sections = useMemo(() => groupRoutes(routes), []);

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex h-screen w-[260px] flex-col bg-white shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      {/* Logo */}
      <div className="flex items-center justify-center px-6 py-4">
        <img
          src={Logo || "/placeholder.svg"}
          alt="Fee Froid"
          className="h-16 w-auto object-contain"
        />
      </div>

      <div className="mx-4 h-px bg-gray-100 dark:bg-white/10" />

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto px-3 py-4">
        <div className="space-y-6">
          {sections.map((section, i) => (
            <SidebarSection
              key={i}
              title={section.title}
              icon={section.icon}
              routes={section.routes}
            />
          ))}
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
